import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageService } from 'src/app/services/language/language.service';
import { PagesService } from 'src/app/services/pages/pages.service';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { PageFormModalComponent } from "../pages/page-form-modal/page-form-modal.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-category',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, SpinnerComponent, PageFormModalComponent],
  templateUrl: './category.component.html',
  styleUrl: './category.component.css'
})
export class CategoryComponent {

  data: any
  load = false
  currentLang = 'ge'
  loadDeleteId: number | null = null;

  selectedItem: string = 'categories'

  error = false

  selectedMenuType: number = 72

  selectedData:  any = null;
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  
  constructor(
    private PagesService: PagesService,
    private langService: LanguageService,
    private modalService: NgbModal,
  ){
    this.currentLang = this.langService.getLanguage();
    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
      this.getItems(this.selectedItem)
    });
    this.getItems(this.selectedItem)
  }

  getItems(type: string){
    this.load = true
    this.PagesService.getCategory(type).subscribe(
      (res: any) => {
        this.error = false
        this.load = false
        this.data = res
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    )
  }

  onChange(){
    this.setId()
    this.getItems(this.selectedItem)
  }

  setId(){
    if(this.selectedItem == 'categories'){this.selectedMenuType = 72}
    if(this.selectedItem == 'municipalities'){this.selectedMenuType = 73}
  }

  add(){
    this.setId()
    this.selectedData = null
    this.modalService.open(this.formModalTemplate, {size: 'lg'})
  }

  edit(data: any){
    this.setId()
    this.selectedData = data
    this.modalService.open(this.formModalTemplate, {size: 'lg'})
  }

  onSaved(){
    
  }

  onCloseModal(){
    this.modalService.dismissAll();
  }

}
